import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { CHART_PIE_COLORS } from "../lib/constants";
import { LabelCurrencyTooltip } from "../tooltips/currency";

import EngineLoader from "$components/loaders/engine-loader";

import "./pie.scss";
import NotificationBar from "$components/notification-bar";
import NoData from "../no-content";
import { isFunction } from "lodash";

const ChartPie = ({ charts = [], colors = CHART_PIE_COLORS, TooltipComponent = LabelCurrencyTooltip }) => {
    if (charts.length === 0 || !charts[0].data) {
        return <EngineLoader />;
    }
    if (charts[0].data.length === 0) {
        return <NoData message="No Parsable Data Available" />;
    }

    const allNegatives = charts[0]?.data.every((v) => v.value <= 0);

    if (allNegatives) {
        return (
            <>
                <NotificationBar message="Can not display chart due to all negative numbers" type="error" />
            </>
        );
    }

    const largestDiameter = charts.reduce((num, c) => {
        return Math.max(num, c.outerRadius * 2 + 50);
    }, 0);

    return (
        <div className="chart-pie" style={{ width: largestDiameter + "px", height: largestDiameter + "px" }}>
            <ResponsiveContainer width="100%" height="100%">
                <PieChart width={largestDiameter} height={largestDiameter}>
                    <Tooltip content={<TooltipComponent />} />
                    {charts.map(({ data, onClick, innerRadius, outerRadius }, i) => {
                        const overrideOnClick =
                            onClick && isFunction(onClick)
                                ? (d, i) => {
                                      const useName = d.label || d.name || "";
                                      if (!useName.toLowerCase().startsWith("other")) {
                                          onClick(d, i);
                                      }
                                  }
                                : null;
                        return (
                            <Pie
                                key={`chart_${i}`}
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={innerRadius}
                                outerRadius={outerRadius}
                                fill="#8884d8"
                                nameKey={"text"}
                                dataKey="value"
                                onClick={overrideOnClick}
                                cursor={!!onClick ? "pointer" : ""}
                            >
                                {data.map((entry, index) => {
                                    return <Cell key={`cell-${index}`} fill={entry.color || colors[index % colors.length]} />;
                                })}
                            </Pie>
                        );
                    })}
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
};

export default ChartPie;
